import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadByTemplateButton, type DownloadTemplateSelection } from '@/entities/download-template';
import type { TranscriptArchiveProgress } from '@/entities/search';

type Props = {
  /** Есть что скачивать: отмечена хотя бы одна строка */
  hasSelection: boolean;
  /** Запуск заблокирован другим действием: набирается «выбрать всё» или идёт удаление */
  isLocked: boolean;
  /** Архив формируется — повторный запуск заблокирован */
  isPending: boolean;
  /** Ход формирования архива; `null`, пока формирование не запущено */
  progress: TranscriptArchiveProgress | null;
  /** Запуск архива по отмеченным диалогам с выбранными шаблоном и форматом */
  onDownload: (selection: DownloadTemplateSelection) => void;
};

/** Скачивание транскрипций отмеченных диалогов одним архивом по выбранным шаблону и формату. */
export const TranscriptArchiveAction: FC<Props> = ({ hasSelection, isLocked, isPending, progress, onDownload }) => {
  const { t } = useTranslation(['dialogs']);

  return (
    <DownloadByTemplateButton
      entityType="TRANSCRIPT"
      onDownload={onDownload}
      isPending={isPending}
      trigger={{
        variant: 'secondary',
        size: 'sm',
        disabled: !hasSelection || isLocked,
        isLoading: isPending,
        children: progress
          ? t('dialogs:dialogListSection.transcriptArchive.progress', progress)
          : t('dialogs:dialogListSection.transcriptArchive.label'),
      }}
    />
  );
};
